import React from "react";

interface MapProps {
  address: string;
  width?: string;
  height?: string;
  className?: string;
  lat?: number;
  lon?: number;
}

const CustomMap = ({
  address,
  width,
  height,
  className,
  lat,
  lon,
}: MapProps) => {
    let mapSrc = "";

    if (lat !== undefined && lon !== undefined) {
        // Use coordinates if available
        mapSrc = `https://www.google.com/maps?q=${lat},${lon}&output=embed`;
    } else if (address) {
        // Otherwise use the address
        const encodedAddress = encodeURIComponent(address);
        mapSrc = `https://www.google.com/maps?q=${encodedAddress}&output=embed`;
    } else {
        return <div>No address or coordinates provided.</div>;
    }

  return (
    <iframe
      width={width}
      height={height}
      className={className}
      style={{ border: 0, borderRadius: "10px" }}
      loading="lazy"
      allowFullScreen
      src={mapSrc}
    ></iframe>
  );
};

export default CustomMap;
